module.exports = __webpack_public_path__ + "static/media/HCMM904.80df9b6e.jpg";